import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the settings of the allocation (50-api/sales.md §2.6, ADR-194): the version in force, the one that
// waits for its instant, and the history of every change.

const settings = api.sales["allocation-settings"];

export type AllocationSettings = InferResponseType<typeof settings.$get, 200>;
export type AllocationSetting = NonNullable<AllocationSettings["inForce"]>;

const keys = { all: ["allocation-settings"] as const };

export const allocationSettingQueries = {
  ...keys,

  get: () =>
    queryOptions({
      queryKey: [...keys.all, "get"],
      queryFn: ({ signal }) => unwrap(settings.$get({}, { init: { signal } })),
    }),

  history: () =>
    infiniteQueryOptions({
      queryKey: [...keys.all, "history"],
      queryFn: ({ pageParam, signal }) =>
        unwrap(settings.history.$get({ query: pageParam ? { cursor: pageParam } : {} }, { init: { signal } })),
      initialPageParam: "",
      getNextPageParam: (last) => last.nextCursor ?? undefined,
    }),
};
